import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=5d87499f&scoped=true&"
import script from "./Accounts.vue?vue&type=script&lang=js&"
export * from "./Accounts.vue?vue&type=script&lang=js&"
import style0 from "./Accounts.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Accounts.vue?vue&type=style&index=1&id=5d87499f&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d87499f",
  null
  
)

export default component.exports